import { TCommonTypes } from './common';

export enum TooltipPositionsEnum {
  TOP = 'TOP',
  BOTTOM = 'BOTTOM',
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
}

export type TooltipProps = {
  children: React.ReactNode;
  content: React.ReactNode;
  tooltipPosition?: TooltipPositionsEnum;
  site?: 'default' | 'mercedes';
  small?: boolean;
  ariaLabel?: boolean;
  tooltipClassName?: string;
  enabledCondition?: boolean;
} & Partial<TCommonTypes>;
